<template>
    <div class="search_wrap">
        <el-date-picker
            v-model="date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            class="mr15"
        ></el-date-picker>
    
        <el-select
            v-model="adSlot"
            filterable
            collapse-tags
            multiple
            clearable
            placeholder="代码位"
            class="select_class mr15"
            size="small"
        >
            <el-option
                v-for="item in adSlotList"
                :key="item.id"
                :label="item.id + ' ' + item.name"
                :value="item.id">
            </el-option>
        </el-select>
    
        <el-input size="small" v-model="productName" placeholder="产品名称" class="input_class mr15"></el-input>

        <el-input size="small" v-model="material_id" placeholder="素材ID" class="input_class mr15"></el-input>
        
        <el-input size="small" v-model="keyword" placeholder="素材标题/素材链接" class="input_class mr15"></el-input>
        
        <el-button type="primary" size="small" @click="handleSearchSubmit">查询</el-button>
    </div>
</template>

<script>
import { getReviewCollectionAdslotList } from '@/apis/advCenter.js';
import { getDate } from '@/common/utils';

export default {
    name: 'audit-search',
    data() {
        return {
            date: [],
            choiceDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.choiceDate = minDate.getTime()
                    if (maxDate) this.choiceDate = '';
                },
                // disabledDate: (time) => {
                //     // return time.getTime() > new Date().getTime() - (1000 * 60 * 60 * 24);
                //     if (this.choiceDate) {
                //         const one = 6 * 24 * 3600 * 1000;
                //         const minTime = this.choiceDate - one;
                //         const maxTime = this.choiceDate + one;
                //         return (
                //             time.getTime() < minTime ||
                //             time.getTime() > maxTime ||
                //             time.getTime() > Date.now()
                //         )
                //     } else {
                //         return time.getTime() > new Date().getTime() - (1000 * 60 * 60 * 24);
                //     }
                // },
                disabledDate: (time) => {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // 设置为当天0点

                    const latestDate = new Date(today);
                    latestDate.setDate(latestDate.getDate() - 1); // 昨天0点

                    const earliestDate = new Date(today);
                    earliestDate.setDate(earliestDate.getDate() - 31); // 31天前0点

                    // 31天范围内
                    if (time.getTime() < earliestDate.getTime() || time.getTime() > latestDate.getTime()) {
                        return true;
                    }

                    // 起始日期 ±6天
                    if (this.choiceDate) {
                        const oneDay = 24 * 3600 * 1000;
                        const minTime = this.choiceDate - 6 * oneDay;
                        const maxTime = this.choiceDate + 6 * oneDay;
                        return (
                            time.getTime() < minTime ||
                            time.getTime() > maxTime ||
                            time.getTime() > Date.now()
                        );
                    } else {
                    // 未选择起始日期时，只能选昨天及更早的日期
                        return time.getTime() > latestDate.getTime();
                    }
                }
            },
            adSlotList: [],
            adSlot: [],
            productName: '',
            keyword: '',
            material_id: ''
        }
    },
    
    props: {
        page: String
    },
    
    methods: {
        init() {
            this.date = [getDate(-1), getDate(-1)];
            this.getAdSlotList();
        },
    
        // 代码位列表
        async getAdSlotList() {
            let params = {
                type: 'bind',
                page_size: 9999
            };
            const {code, data} = await getReviewCollectionAdslotList(params);
            if (code && code === 200) {
                this.adSlotList = data.list;
            }
        },
        
        // 确认搜索
        handleSearchSubmit() {
            this.$emit('callback', {
                date: this.date,
                adSlotId: this.adSlot,
                productName: this.productName,
                keyword: this.keyword,
                material_id: this.material_id
            });
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>
<style lang="scss">
.el-tag.el-tag--info{max-width: 150px;}
</style>
<style lang="scss" scoped>
.search_wrap{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & .mr15{margin-right: 15px;}
    & .input_class{
        width: 200px;
    }
    & .select_class{
        width: 240px;
    }
}
</style>
